<template>
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="withdraw_box">
      <div class="left">
        <leftTemplate :left_tabShow="'withdraw'"></leftTemplate>
      </div>

      <div class="right">
        <div>
          <div style="
              padding: 0.2rem 0.16rem 0;
              box-sizing: border-box;
              display: flex;
              justify-content: space-between;
            ">
            <div>
              <!-- {{ userObj.amount }} -->
              <div style="font-size: 0.14rem">
                待提现金额<span style="font-size: 0.24rem; color: #c01a26">{{
                  userObj.amount ? (userObj.amount / 1).toFixed(2) : 0
                }}</span>元
              </div>

              <div style="
                  display: flex;
                  font-size: 0.14rem;
                  color: #333333;
                  margin: 0.16rem 0 0.12rem;
                ">
                <!-- <div>
									<span>待结算</span>
									<span>0.00</span>
									<span>元</span>
								</div> -->
                <div>
                  <span>已提现</span>
                  <span>{{
                    userObj.out ? (userObj.out / 1).toFixed(2) : 0
                  }}</span>
                  <span>元</span>
                </div>
              </div>
            </div>
            <div style="display: flex">
              <div class="withdraw_bnt" @click="exportt">导出</div>
              <div class="withdraw_bnt" style="background: #2a78ff; color: #fff; border: none" @click="handleCard">
                提现
              </div>
            </div>
          </div>
          <div style="
              font-size: 0.12rem;
              color: #86909c;
              margin: 0.02rem 0;
              padding: 0.12rem;
              box-sizing: border-box;
            ">
            截止每周日账户余额 ≥ 100
            元时，打款将在下周三24:00前处理，如遇法定节假日，将顺延至工作周的第一天处理（到账时间请以银行为准）
          </div>
          <!-- {{ tableData }} -->
          <el-table ref="multipleTableRef" :data="tableData" style="width: 100%" height="450">
            <el-table-column label="提现日期" align="center" property="updateTime" />
            <el-table-column label="金额" align="center" property="outMoney">
              <template #default="scope">
                <div>
                  <span>￥</span>{{ (scope.row.outMoney / 1).toFixed(2) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" property="outMoney">
              <template #default="scope">
                <el-tag :type="scope.row.status == 1 ? 'success' : scope.row.status == 0 ? 'primary' : 'danger'">
                  {{ scope.row.status == 1 ? "提现成功" : scope.row.status == 0 ? "审核中" : "审核失败" }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 成功 -->

        <!-- <div style="padding: 2rem 0;">
					<div style="width: 0.48rem;height: 0.48rem;margin:0 auto 0.16rem;">
						<img style="width: 100%;height: 100%;" src="@/assets/img/tips／check-circle-fill@2x.png" />
					</div>
					<div
						style="color: #333333;font-size: font-size: 0.14rem;margin-bottom: 0.04rem;text-align: center;">
						操作成功</div>
					<div style="color: #86909C;font-size: 0.14rem;text-align: center;margin-bottom: 0.22rem;">预计2小时内到账
					</div>
					<div style="display: flex;justify-content: center;">
						<span class="controls">返回交易记录</span>
					</div>

				</div> -->

        <!-- 失败 -->

        <!-- <div style="padding: 2rem 0;">
					<div style="width: 0.48rem;height: 0.48rem;margin:0 auto 0.16rem;">
						<img style="width: 100%;height: 100%;" src="@/assets/img/tips／close-circle-fill@2x.png" />
					</div>
					<div
						style="color: #333333;font-size: font-size: 0.14rem;margin-bottom: 0.04rem;text-align: center;">
						操作失败</div>
					<div style="color: #86909C;font-size: 0.14rem;text-align: center;margin-bottom: 0.22rem;">请核对信息后，再重试
					</div>
					<div style="display: flex;justify-content: center;">
						<span class="controls">返回交易记录</span>
						<span class="controls controls2">重新提现</span>
					</div>
				</div> -->
      </div>
    </div>
    <!-- 去认证 -->
    <el-dialog title="" v-model="addAuthenVisible" align-center width="480px" :close-on-click-modal="false">
      <gotoAuthentication></gotoAuthentication>
    </el-dialog>
    <!-- 添加银行卡后提现 -->
    <el-dialog title="添加银行卡" v-model="addCardVisible" align-center width="480px" :close-on-click-modal="false">
      <bacnk-card-add @submit="onSubmit"></bacnk-card-add>
    </el-dialog>
    <!-- 提现 -->
    <el-dialog title="提现" v-model="addWithdrawVisible" align-center width="480px" :before-close="handleClose"
      :close-on-click-modal="false">
      <add-withdraw :handleClose="handleClose" :bankList="myBankList"></add-withdraw>
      <!-- <addWithdraw></addWithdraw> -->
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate from "@/components/leftTemplate.vue";
import bacnkCardAdd from "@/components/card/bacnk_card_add.vue";
import gotoAuthentication from "@/components/card/gotoAuthentication.vue";
import addWithdraw from "@/components/card/addWithdraw.vue";
import { ref } from "vue";
import { ElTable } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";
import axioss from "axios";
// 表格
document.title = "标识山西-提现";
interface User {
  price: string;
  time: string;
}

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
// 提现金额
const userObj = ref({});
const getInfo = () => {
  Axios("get", "/member/account-manage/info", false, false, (res) => {
    // myBankList.value = res.data.data;
    // console.log(res.data);
    userObj.value = res.data.data;
  });
};
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
const tableData = ref([]);
// 提现数据列表
const arraymylist = () => {
  Axios("GET", "/member/member-out/my-list", null, false, function (res: any) {
    if (res.data.code === 200) {
      tableData.value = res.data.rows;
    }
  });
};
const myBankList = ref([]);
// 获取银行卡个数
const bankNumF = () => {
  Axios("get", "/member/member-bank/my-list", false, false, (res) => {
    myBankList.value = res.data.data;
  });
};
getInfo();
arraymylist();
bankNumF();
//添加银行
let addCardVisible = ref(false);
const handleCard = () => {
  if (myBankList.value.length == 0) addCardVisible.value = true;
  else addWithdrawVisible.value = true;
};
import { serverBaseUrl } from "@/assets/js/ls_tgServerUrls.js";
const exportt = () => {
  axioss({
    method: "POST",
    url: serverBaseUrl + "/member/member-out/member-export",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("token")
        ? "Bearer " + localStorage.getItem("token")
        : "",
      "Access-Control-Allow-Origin": "*",
    },
  }).then((res) => {
    const link = document.createElement("a");
    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
    link.style.display = "none";
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "提现流水.xls");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });

  // "POST", "/member/member-out/member-export", {}, false, (res) => {
  // 	console.log('res', res);

  // const link = document.createElement("a");
  // let blob = new Blob([res], { type: "application/vnd.ms-excel" });
  // link.style.display = "none";
  // link.href = URL.createObjectURL(blob);
  // link.setAttribute("download", "提现流水.xls");
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
};
//认证
let addAuthenVisible = ref(false);
const handleAuthen = () => {
  addAuthenVisible.value = true;
};
//提现
let addWithdrawVisible = ref(false);
const onSubmit = () => {
  bankNumF();
  addCardVisible.value = false;
};
//关闭
const handleClose = (type) => {
  addWithdrawVisible.value = false;
  if (type) {
    getInfo();
    arraymylist();
    bankNumF();
  }
};
</script>
<style scoped>
@import url(/src/assets/css/left_right.css);

.withdraw_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

.withdraw_bnt {
  height: 0.45rem;
  padding: 0.12rem 0.4rem;
  border-radius: 0.08rem;
  box-sizing: border-box;
  font-size: 0.14rem;
  font-weight: 400;
  color: #86909c;
  border: 1px solid #ccc;
  margin-left: 0.16rem;
}

.controls {
  width: 1.16rem;
  height: 0.37rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  border: 0.01rem solid #86909c;
  text-align: center;
  line-height: 0.37rem;
  cursor: pointer;
}

.controls2 {
  width: 0.88rem;
  color: #fff;
  border: none;
  background: #ff6000;
  margin-left: 0.2rem;
}
</style>
